import React, { useState, useRef, useEffect } from 'react';
import {
  IconBuildingStore, IconPaperBag,
  IconSquareRoundedPlusFilled, IconPlus,
  IconSquareRoundedArrowDownFilled, IconArrowDown,
  IconSquareRoundedArrowUpFilled, IconArrowUp
} from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

const buttons = [
  { name: 'Create order', icon: IconPlus },
  { name: 'Fund wallet', icon: IconArrowUp },
  { name: 'Withdraw', icon: IconArrowDown }
];

const ActionButtons: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  // Close menu on outside click
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    }
    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  const handleCreateOrder = (role: 'seller' | 'buyer') => {
    setMenuOpen(false);
    navigate(`/escrow/new?role=${role}`);
  };

  return (
    <div className="flex space-x-1 sm:space-x-4 relative justify-between">
      {buttons.map((bt, idx) => (
        <div key={bt.name} className="relative">
          <button
            className="sm:bg-transparent sm:border sm:border-primary-600 sm:px-4 py-2 sm:rounded-lg 
            bg-[#eceff0] text-primary-600 px-1.5 py-3 rounded-md font-light focus:outline-primary-500"
            onClick={
              bt.name === 'Create order'
                ? () => setMenuOpen((open) => !open)
                : () => navigate(`/${bt.name === 'Withdraw' ? 'withdrawal' : 'funding'}`)
            }
          >
            <div className="flex space-x-2 items-center">
              <bt.icon className="w-4 h-3 sm:w-6 sm:h-5" />
              <span className='text-sm sm:text-[16px] m-0'>{bt.name}</span>
            </div>
          </button>

          {bt.name === 'Create order' && menuOpen && (
            <div
              ref={menuRef}
              className="absolute left-0 z-10 mt-2 w-56 rounded-xl shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none p-4 flex flex-col space-y-4"
            >
              <button
                className="flex items-center space-x-3 px-2 py-2 rounded-lg hover:bg-gray-100 w-full text-left"
                onClick={() => handleCreateOrder('seller')}
              >
                <IconBuildingStore className="w-6 h-6 text-gray-600" />
                <span className="text-gray-800">As a seller</span>
              </button>
              <button
                className="flex items-center space-x-3 px-2 py-2 rounded-lg hover:bg-gray-100 w-full text-left"
                onClick={() => handleCreateOrder('buyer')}
              >
                <IconPaperBag className="w-6 h-6 text-gray-600" />
                <span className="text-gray-800">As a buyer</span>
              </button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ActionButtons; 